import React from 'react'
import { useNavigate } from 'react-router-dom'

import {
  formatCurrency,
  formatDateTime,
  getTimezoneDate,
  sort,
  timezones,
} from '../../../utilities/helpers'

import Card from 'react-bootstrap/Card'
import Stack from 'react-bootstrap/Stack'
import Button from 'react-bootstrap/Button'

import './lists.scss'

function getAccessPassDateRange(accessPass, timezone) {
  if (accessPass?.onlineStart || accessPass?.onlineEnd) {
    return {
      start: accessPass.onlineStart,
      end: accessPass.onlineEnd,
    }
  }

  const events = sort(accessPass?.events || [])
  return {
    start: events[0]?.start,
    end: events[events.length - 1]?.start,
  }
}

export default function PackagesList({ venue, packages, accessPasses = [] }) {
  const navigate = useNavigate()
  const timezone = timezones(venue?.timezone)
  const items = [...(packages || []), ...(accessPasses || [])]

  return (
    <>
      {items.length > 0 ? (
        <Stack as="ul">
          {items.map((item, idx) => {
            const isAccessPass = item?.productType === 'access_pass'
            const dateRange = isAccessPass
              ? getAccessPassDateRange(item, timezone)
              : { start: item.start, end: item.end }
            const imageUrl = isAccessPass
              ? item?.artwork?.url
              : item?.image?.url
            const price = isAccessPass
              ? item?.price
              : item?.pricingTiers?.[0]?.price
            const detailPath = isAccessPass
              ? `access-pass/${item.uuid}`
              : `package/${item.uuid}`

            return (
              <Card
                body
                as="li"
                key={item.uuid || idx}
                className="card-xs card--light item"
              >
                <Stack
                  gap={2}
                  className="flex-md-row gap-md-3 justify-content-md-between"
                >
                  <Stack
                    direction="horizontal"
                    gap={3}
                    className="image-event-info-wrapper"
                  >
                    {imageUrl && (
                      <Card.Img
                        src={imageUrl}
                        alt={`Cover art for ${item?.name} ${isAccessPass ? 'access pass' : 'package'}`}
                        width="100"
                        height="100"
                        className="event-image"
                      />
                    )}
                    <div className="event-info">
                      <div className="event-name-date-wrapper">
                        <span className="text-muted caption--uppercase">
                          {isAccessPass ? 'Access Pass' : item?.category?.name}
                        </span>
                        <p className="normal normal-bold">{item?.name}</p>
                      </div>
                      {dateRange.start && (
                        <div className="tablet-desktop-only">
                          <span className="event-date">
                            <span>
                              {formatDateTime(
                                getTimezoneDate(dateRange.start, timezone),
                                'dateOnly'
                              )}
                            </span>
                            {dateRange.end && (
                              <span className="to">
                                <span>
                                  {formatDateTime(
                                    getTimezoneDate(dateRange.end, timezone),
                                    'dateOnly'
                                  )}
                                </span>
                              </span>
                            )}
                          </span>
                        </div>
                      )}
                    </div>
                  </Stack>
                  {dateRange.start && (
                    <div className="mobile-only">
                      <span className="event-date">
                        <span>
                          {formatDateTime(
                            getTimezoneDate(dateRange.start, timezone),
                            'dateOnly'
                          )}
                        </span>
                        {dateRange.end && (
                          <span className="to">
                            <span>
                              {formatDateTime(
                                getTimezoneDate(dateRange.end, timezone),
                                'dateOnly'
                              )}
                            </span>
                          </span>
                        )}
                      </span>
                    </div>
                  )}
                  <div className="btn-flex-group">
                    <Button
                      className="mt-0"
                      onClick={() => navigate(detailPath)}
                    >
                      From {formatCurrency(price)}
                    </Button>
                  </div>
                </Stack>
              </Card>
            )
          })}
        </Stack>
      ) : (
        <Stack className="align-items-center">
          <h1 className="fs-md">No packages</h1>
          <p className="subtitle">This venue has no packages</p>
        </Stack>
      )}
    </>
  )
}
